<script setup>
import ImgsSliderWithButtons from '../sliders/ImgsSliderWithButtons.vue'

// import assetSlider1 from '@/assets/app_slider/1.webp';
// import assetSlider2 from '@/assets/app_slider/2.webp';
// import assetSlider3 from '@/assets/app_slider/3.webp';
// import assetSlider4 from '@/assets/app_slider/4.webp';
// import assetSlider5 from '@/assets/app_slider/5.webp';

const imgsArray = window.imagesSlider


</script>

<template>
   
   <ImgsSliderWithButtons :images="imgsArray" />
   <!-- <ImgsSliderWithButtons :images="[
      assetSlider1,
      assetSlider2,
      assetSlider3,
      assetSlider4,
      assetSlider5,
   ]" /> -->
</template>
